/**
 * Usage:
 * {{ user | fullname }} => 'Bolek Novák'
 */
Vue.filter('fullname', function(user) {
    if (!user) return ''
    return [user.name, ' ', user.surname].join('')
})

/**
 * Usage:
 * {{ user | initials }} => 'BN'
 */
Vue.filter('initials', function(user) {
    if (!user) return ''
    return (user.name.charAt(0) + user.surname.charAt(0)).toLocaleUpperCase()
})

/**
 * Usage:
 * {{ 'bolek' | capitalize }} => 'Bolek'
 */
Vue.filter('capitalize', function(string) {
    if (typeof string !== 'string') return ''
    return string.charAt(0).toLocaleUpperCase() + string.slice(1)
})

/**
 * Usage:
 * {{ moment() | dayName }} => 'středa'
 */
Vue.filter('dayName', function(date) {
    return date.format('dddd')
})

/**
 * Usage:
 * {{ user | phone }} => '+420 777666555'
 */
Vue.filter('phone', function(user) {
    if (!user) return ''
    let phone_country
    if(user.phone_country === 'CZ') phone_country = '+420'
    if(user.phone_country === 'DE') phone_country = '+49'
    if(user.phone_country === 'SK') phone_country = '+421'
    return [phone_country, ' ', user.phone].join('')
})